<!--企业数字化解决方案-->
<template>
  <div class="home">
    <div class="title banner-amt">
      <h1>企业数据管理解决方案</h1>
      <p>帮助企业构建数据治理体系，促进数据要素共享开放，加速释放数据价值</p>
    </div>
    <div class="content">
      <div v-for="(item,index) in list" :key="item.title" class="content_item">
        <div class="content_text" :style="{float: (index%2) === 0 ? 'left' : 'right'}">          
          <div class="content_num">
            <span class="content_number">0{{index+1}}</span>
            <h2>{{item.title}}</h2>
          </div>
          <p v-for="text in item.content" :key="text">{{text}}</p>
        </div>
        <div class="content_img" :style="{textAlign: (index%2) === 0 ? 'right' : 'left'}">
          <img :src="item.url" alt="" class="svg_style">
        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <span>一分钟快速接入API服务</span>
        <el-button class="btn" size="small" @click='$router.push("Index")'>联系我们</el-button>
    </div> -->
  </div>
</template>
<script>
/* eslint-disable */
export default {
  metaInfo: {
    title: '企业数据管理解决方案',
    meta: [
      {
        name: 'keywords',
        content: '数据采集转发,数据集成共享,数据要素开放流通,企业数字化咨询,API全生命周期管理'
      },
      {
        name: 'description',
        content: '帮助企业构建数据治理体系，促进数据要素共享开放，加速释放数据价值'
      }
    ]
  },
  data() {
    return {
      current: ['setting1'],
      list: [
        {
          title: '数据采集转发',
          content: ['软硬件一体化方案，实现电力企业各类数据共享打通，全方位保障数据安全','穿透电力行业网络分区限制，符合电力行业安全标准','支持百余种电力及工业通讯协议的数据采集转发，一站式交付服务为项目落地保驾护航','设备、协议统一管理，设备模型快速映射，沉淀企业数据资产'],
          url: require('../assets/01.png')
        },
        {
          title: '数据集成共享',
          content: ['从数据层面解决数据孤岛，数据不一致性问题','集中各系统中的数据，实现多种异构数据源集成，实现数据的实时汇聚、分发与共享','多个业务系统之间实现数据的实时同步，准确传输，从而实现业务操作的连贯性'],
          img: '03',
          url: require('../assets/02.png')
        },
        {
          title: '数据要素开放流通',
          content: ['覆盖“采”“存”“管”“用”“服”数据链路，实现数据高效便捷流通','整合数据资源，提升数据质量，保障数据安全，衍生数智应用，释放数据价值','通过数据共享、数据开放和数据交易促进数据流通，加快数据要素资源化-资产化-资本化进程'],
          img: '04',
          url: require('../assets/03.png')
        },
        {
          title: '企业数字化咨询',
          content: ['深耕新能源领域，洞察行业先机，促进数字化重塑','提供覆盖行业政策解读，企业战略研究，业务调研及数智化提升的全链路数字化转型规划方案','帮助企业快速定位数字化转型痛点，从业务、应用、数据、技术多位切入，全方面规划转型蓝图，合理化布局转型演进路线'],
          url: require('../assets/04.png')
        },
        {
          title: 'API全生命周期管理',
          content: ['建立贯穿API创建-分类-发布-调用-下架全生命周期标准化管理体系','全方位API服务调用监控告警，保障服务链路安全合规','构建企业API资产目录，帮助企业沉淀API能力资产，提升API服务可复用性，促进API价值最大化'],
          url: require('../assets/05.png')
        },
      ],
      tenantId: ''
    }
  },
  created() {
    window.scrollTo({ top:0, behavior:"smooth" });
  }
}
</script>
<style scoped lang='scss'>
// .banner-amt {
//   animation: bannerAmt 1.5s ease-in-out 0s 1 normal both; /*bannerAmt 1.5s ease-in-out .1s 1 normal both;*/ 
//   -webkit-animation: bannerAmt 1.5s ease-in-out 0s 1 normal both;/*bannerAmt 1.5s ease-in-out .1s 1 normal both;*/
// }
.home {
  width: 100%;
  // padding-top: 30px;
  // background-image: url('../assets/jjfa_12.png');
  // background-repeat: no-repeat;
  // background-size: cover;//contain; // // 缩小图片来适应元素的尺寸（保持像素的长宽比），是图片宽高最长的那个边覆盖元素一边；
  // background-position: left left;
  .title {
    background-image: url('../assets/jjfa_12.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;

    padding: 0 10%;
    width: 100%;
    height: calc(100vh + 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 15%;
    h1,p {
      color: #fff;
      z-index: 1;
    }
    h1 {
      font-size: 60px;
    }
    p {
      width: 886px;
      font-size: 40px;
    }
  }
  .title::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    background: rgba(0,0,0,0.35);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .content {
    background: #000;//#04070a;
    padding: 0 15%;
    width: 100%;
    .content_item {
      height: 800px;
      .content_text {
        width: 42%;
        .content_num {
          position: relative;
          h2 {
            font-size: 42px;
            color: #fff;
            font-weight: 600;
            margin-bottom: 50px;
          }
          .content_number {
            color: rgba(220,220,220,0.2);
            font-size: 160px;
            position: absolute;
            top: -130px;
            left: -100px;
            z-index: 0;
          }
        }
        p {
          font-size: 28px;
          color: #eee;
          font-weight: 300;
          margin-bottom: 30px;
          line-height: 48px;
        }
      }
      .content_img {
        width: 100%;
        .svg_style {
          width: 500px;
        }
        .svg_style:nth-of-type(1) {
          margin-top: -50px;
          width: 450px;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 40px;
    // position: fixed;
    bottom: 0;
    background: #0272dc;
    padding: 0 10%;
    display: flex;
    justify-content: space-between;
    span {
      line-height: 40px;
      color: #fff;
      font-size: 16px;
    }
    .btn {
      height: 30px;
      margin-top: 5px;
      a {
        color: #1890FF;
      }
    }
  }
}
// @keyframes bannerAmt{
//   0%{
//     background-size: 150% 150%;
//   }
//   100%{
//     background-size: 100% 100%;
//   }
// }
</style>
